<template>
    <div class="container">
        <div class="top-container">
            <h1 class="title">Application Denied</h1>
            <p class="caption">
                We could not approve your apolication at this moment. Please re-apply in 15 days
            </p>
        </div>
        
        <div class="spare-time">
            <p class="st-caption">
                You can re-apply for
            </p>
            <p class="st-content">
                <em v-text="route.query.day"></em>
                <span class="text">Days</span>
                <em v-text="route.query.hour"></em>
                <span class="text">Hours</span>
            </p>
        </div>
        <div class="btn-container">
            <a href="javascript:void(0);" class="btn-submit" @click="go">Back</a>
        </div>
    </div>
</template>
<script>
import {useRouter} from 'vue-router'
export default {
    setup () {
        const router = useRouter()
        const route = router.currentRoute
        const go = ()=>{
            router.push({
                "path":"/"
            })
        }
        return {
            route
            ,go
        }
    }    
}
</script>
<style lang="less">
    .container{
        padding:30px;
        .btn-container{
            position:fixed;
            bottom:50px;
            left:0;
            width: 100%;
            height: 96px;
            .btn-submit{
                display: block;
                width: 670px;
                height: 96px;
                line-height: 96px;
                text-align: center;
                border-radius: 12px;
                background:#C393FF;
                font-size: 32px;
                margin:0 auto;
                color:#fff;
            }
        }
        .spare-time{
            margin-top: 50px;
            .st-caption{
                text-align: center;
                color:#C393FF;
                font-size: 35px;
                margin-bottom: 30px;
            }
            .st-content{
                color:#999999;
                font-size: 30px;
                text-align: center;
                em{
                    color:#C393FF;
                    font-size: 34px;
                    font-weight: 700;
                    margin-right: 10px;
                    margin-left: 10px;
                }

            }
        }
        .top-container{
            width: 650px;
            height:200px;
            padding:30px 0;
            margin:0 auto;
            border-radius: 20px;
            background:#cebbfb;            
            .title{
                padding:30px 0;
                font-size: 40px;
                color:#fff;
                text-align: center;
            }
            .caption{
                text-align: center;
                font-size: 30px;
                line-height: 1.5;
                color:#fff;
            }
        }
        
    }
</style>